let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lPTit")).then(() => parcelRequire('h9uSI'));